<template>
  <div class="icp_card">
    <div class="company_info">
      <span>公司名称：北京神墨文化传播有限公司;</span>
      <span>&nbsp;&nbsp;</span>
      <span
        >地址及电话：北京市海淀区长春桥路7号万柳亿城大厦C1-1203&nbsp;010-58815008;</span
      >
    </div>
    <div class="copyright_info">
      <span>© Copyright 神墨学堂</span>
      <span>&nbsp;&nbsp;</span>
      <a href="http://beian.miit.gov.cn" target="_blank">
        <span style="color: #000">京ICP备14002894号-8</span>
      </a>
      <span>&nbsp;&nbsp;</span>
      <img src="@/assets/icp.png" />
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032311"
        >京公网安备 11010802032311号</a
      >
    </div>
  </div>
</template>

<style scoped>
.icp_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.icp_card {
  padding: 0 0 20px;
}

.company_info {
  font-size: 12px;
}

.copyright_info {
  font-size: 12px;
}

.copyright_info > a {
  text-decoration: none;
}
</style>
